export const MuiInputBase = {
  styleOverrides: {
    root: {
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: '#fff',
      },
      '&.Mui-focused': {
        backgroundColor: '#fff',
      },
    },
  },
};
